import React from 'react'
import {Box, Link, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'

const GoogleRecatpcha = ({isStandardLogin, enabledIDPs, isLoginPage }) => {
    return (
        <Box>
            {isStandardLogin && !isLoginPage && (
                <Text
                    fontSize="12px"
                    textAlign="left"
                    color="gray.700"
                    fontWeight="400"
                    lineHeight="15px"
                    marginTop={enabledIDPs ? {base: '-45px', lg: '-50px'} : 0}
                    marginBottom={0}
                    px={isLoginPage && {base: 4, lg: 0}}
                    pr={!isLoginPage && '1px'}
                    as={'span'}
                >
                    <FormattedMessage
                        defaultMessage="By continuing, you agree to our {termsLink} and {privacyLink}."
                        id="login_form.message.terms_privacy"
                        values={{
                            termsLink: (
                                <Link
                                    href="/terms-conditions.html"
                                    textDecoration="underline"
                                    color="gray.700"
                                >
                                    <FormattedMessage
                                        defaultMessage="Terms & Conditions"
                                        id="login_form.link.terms_conditions"
                                    />
                                </Link>
                            ),
                            privacyLink: (
                                <Link
                                    href="/privacy-policy.html"
                                    textDecoration="underline"
                                    color="gray.700"
                                >
                                    <FormattedMessage
                                        defaultMessage="Privacy Policy"
                                        id="login_form.link.privacy_policy"
                                    />
                                </Link>
                            )
                        }}
                    />
                </Text>
            )}
            <Text textStyle={'bodyXsRegular'} color={'webTypo.textTertiary'} as={'span'}>
                <FormattedMessage
                    id="google_recatpcha.message"
                    defaultMessage="This site is protected by reCAPTCHA and the Google <privacyPolicy>Privacy Policy</privacyPolicy> and <termsOfService>Terms of Service</termsOfService> apply"
                    values={{
                        privacyPolicy: (chunks) => (
                            <Link
                                textDecoration="underline"
                                href="https://policies.google.com/privacy"
                                isExternal
                            >
                                {chunks}
                            </Link>
                        ),
                        termsOfService: (chunks) => (
                            <Link
                                textDecoration="underline"
                                href="https://policies.google.com/terms"
                                isExternal
                            >
                                {chunks}
                            </Link>
                        )
                    }}
                />
            </Text>
        </Box>
    )
}

export default GoogleRecatpcha
